// Core packages

// Third party packages

// Custom packages
import { BaseModel } from '../_base/model.class';

/**
 * Script start
 */

export class Ddt extends BaseModel {
  constructor(
    private _id?: string,
    private code?: string,
    private status?: Date,
    private createdAt?: Date,
  ) {
    super();

    this.setRequiredFields([
      '_id',
      'code',
      'status',
      'createdAt',
    ]);
  }
}
